RivalIQ.module('landscape.views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.CompanyAddTypeahead = Marionette.ItemView.extend({
        minLength: 3,
        itemsToReturn: 8,
        maxPathChars: 38,
        events: {
            'keypress': 'onKeypress'
        },
        currentList: {},
        selection: null,

        initialize: function () {

            const me = this;

            me.showUserInput = me.options.showUserInput || false;

            // the techniques for using objects rather than strings in the
            // bootstrap typeahead were borrowed from http://stackoverflow.com/a/16159942
            me.$el.typeahead(me.getTypeaheadOptions());
        },
        getTypeaheadOptions: function () {

            const me = this;

            return {
                source: function (query, process) {

                    const cleanSearch = RivalIQ.utils.typeaheadPreclean.cleanSearch(query);
                    // reset our flag
                    me.selectionMade = false;

                    me.currentQuery = query;

                    if (cleanSearch && cleanSearch.hostQuery && !me.queryUnderway) {
                        // if we are searching...then don't search again...that's silly
                        me.queryUnderway = true;
                        $.ajax({
                            url: '/api/searchByUrl',
                            type: 'post',
                            data: {
                                hostQuery: cleanSearch.hostQuery,
                                pathQuery: cleanSearch.pathQuery
                            },
                            dataType: 'json',
                            success: function (result) {

                                if (me.showUserInput) {
                                    // show what the user typed at the top of the results if it's not already in the list
                                    // match what we have based on everything after http://, https://, www.

                                    let matchingIndex = -1;
                                    const splitUrl = me.currentQuery.split(/(?:^https?:\/\/)|(?:www.)|(\/(.+))/).filter(Boolean);
                                    const host = splitUrl[0];
                                    const path = splitUrl[1] || '';

                                    _.find(result, function (company, index) {
                                        const companyHost = company.host.split(/(?:www.)/).filter(Boolean)[0];

                                        if (companyHost === host && ((Boolean(path) && company.path === path) || (!path && !company.path))) {
                                            matchingIndex = index;
                                        }
                                    });

                                    let results = result;

                                    if (matchingIndex === -1 && host && Boolean(host.match(/[.](.+)/))) {
                                        // don't show the user input in drop down if it doesn't have .[something]
                                        results = [{
                                            host: me.currentQuery,
                                            isUserInput: true
                                        }].concat(result);
                                    }

                                    return me.typeaheadSuccess(results, process, cleanSearch.protocol);
                                } else {
                                    return me.typeaheadSuccess(result, process, cleanSearch.protocol);
                                }
                            },
                            error: function (result) {
                                return me.typeaheadError(result, process, cleanSearch.protocol);
                            }
                        });
                    } else {
                        // return the empty array so that when our search conditions aren't met, we clear the list

                        return process([]);
                    }

                },
                updater: function (selectedItem) {

                    // the user has made a selection...set a flag so that any running ajax calls know to abort
                    me.selectionMade = true;
                    me.selection = me.currentList[selectedItem];

                    const pubsub = me.options.pubsub || App;

                    if (me.selection.isUserInput) {
                        pubsub.trigger('company-add-autocomplete-search', me.selection);
                    } else {
                        pubsub.trigger('company-add-autocomplete', me.selection);
                    }

                    return me.selection.host;
                },
                minLength: me.minLength,
                items: me.itemsToReturn
            };
        },
        typeaheadSuccess: function (result, process, protocol) {

            const me = this;
            me.currentList = {};
            const resultList = result.map(function (item) {

                if (item.isUserInput) {
                    me.currentList[item.host] = item;
                    return item.host;
                }

                // only show the first two parts of the path and limit the result to 28 chars
                let shortPath = item.path.replace(/^([^/]+)\/([^/]*).*$/, '$1/$2');

                if (shortPath) {
                    shortPath = `/${shortPath}`;
                }
                let totalPath = protocol + item.host + shortPath;
                if (totalPath && totalPath.length > me.maxPathChars - 3) {
                    totalPath = `${totalPath.slice(0, me.maxPathChars - 3)}...`;
                }
                const stringOutput = `${totalPath} - ${item.company_name}`;
                me.currentList[stringOutput] = item;
                return stringOutput;
            });
            // if the user has already made a selection, abort
            if (me.selectionMade) {
                me.selectionMade = false;
                me.queryUnderway = false;
                return;
            }
            me.queryUnderway = false;

            return process(resultList);

        },
        typeaheadError: function (result, process) {
            const me = this;
            // if the user has already made a selection, abort
            if (me.selectionMade) {
                me.selectionMade = false;
                me.queryUnderway = false;
                return;
            }
            me.queryUnderway = false;
            return process([]);
        },
        onKeypress: function (e) {

            const me = this;

            if (e.keyCode === 13) {

                // NOTE prevents navigation on validation failure
                return me.validate();
            }
        },
        validate: function () {

            const me = this;
            const domain = $.trim(me.$el.val());

            me.$el.focus();
            const pubsub = me.options.pubsub || App;

            //check for bad values
            if (!domain || !domain.match(/\./)) {

                pubsub.trigger('company-add-error', {
                    type: 'InvalidDomain',
                    domain: domain
                });
                return false;
            }

            return true;
        }
    });

});
